import { render } from "./tpl_flex_five.vue?vue&type=template&id=8f633292&scoped=true"
import script from "./tpl_flex_five.vue?vue&type=script&lang=js"
export * from "./tpl_flex_five.vue?vue&type=script&lang=js"

import "./tpl_flex_five.vue?vue&type=style&index=0&id=8f633292&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f633292"],['__file',"src/views/wap/template/tpl_flex_five.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8f633292"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8f633292', __exports__)) {
    console.log('reload')
    api.reload('8f633292', __exports__)
  }
  
  module.hot.accept("./tpl_flex_five.vue?vue&type=template&id=8f633292&scoped=true", () => {
    console.log('re-render')
    api.rerender('8f633292', render)
  })

}


export default __exports__